import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';

const chartConfig: ChartConfig = {
  count: { label: 'عدد الشحنات', color: 'hsl(217, 91%, 60%)' },
};

interface Props {
  data: { city_name: string; count: number }[];
}

export function TopCitiesChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  const colors = [
    'hsl(217, 91%, 60%)',
    'hsl(142, 72%, 42%)',
    'hsl(38, 92%, 50%)',
    'hsl(262, 80%, 60%)',
    'hsl(190, 70%, 50%)',
    'hsl(0, 84%, 60%)',
    'hsl(300, 70%, 55%)',
    'hsl(160, 60%, 45%)',
    'hsl(25, 90%, 55%)',
    'hsl(200, 80%, 55%)',
  ];

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 4, right: 20, left: 8, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} className="stroke-border/40" />
        <XAxis type="number" tick={{ fontSize: 11 }} />
        <YAxis dataKey="city_name" type="category" width={80} tick={{ fontSize: 11 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          formatter={(v: any) => [v, 'شحنة']}
        />
        <Bar dataKey="count" radius={[0, 4, 4, 0]}>
          {data.map((_, i) => (
            <Cell key={i} fill={colors[i % colors.length]} />
          ))}
        </Bar>
      </BarChart>
    </ChartContainer>
  );
}
